export const colors = {
    TextDarkGrey: '#45424E',
    TextSubtleGrey: '#6D7682',
    TextDisabled: '#8B96A3',
    TextWhite: '#FFFFFF',
    TextHighlight1: '#1C0F51',
    TextHighlight2: '#4E4785',
    ErrorClick: '#B93751',
    ErrorDefault: '#AC1936',
    ErrorHover: '#991630',
    SuccessClick: '#008A7A',
    SuccessDefault: '#006F62',
    SuccessHover: '#005C52',
    PrimaryClick: '#6864A0',
    PrimaryDefault: '#4E4785',
    PrimaryHover: '#342A6A',
    SecondaryPendingDefault: '#F5C9A0',
    SecondaryPendingHover: '#F2B57D',
    SecondaryPendingDraftHover: '#FDF5EE',
    SecondaryAcceptedDefault: '#73DDC0',
    SecondaryAcceptedHover: '#40D0A9',
    SecondaryAcceptedDraftHover: '#EBFAF6',
    OtherDefault: '#BFBFDC',
    OtherHover: '#B5B5D1',
    OtherDraftHover: '#F2F2F8',
    WarningBackground: '#FAE1CB',
    ErrorBackground: '#FFE9ED',
    NewlyEdited: '#FFF1C0',
    GreyDivider: '#c5cad1',
    Grey1: '#F7F9FC',
    Grey2: '#EDF1F5',
    Grey3: '#DAE1E9',
    Grey4: '#AEB8C5',
    Grey5: '#8B96A3',
    Grey6: '#6D7682',
    Grey7: '#45424E',
    White: '#FFFFFF',
    AccentGreen: '#00C18C',
    AccentBrand: '#8080BA',
    AccentPurple: '#1C0F51',
    Transparent: 'transparent',
    ShiftInProgress: '#ADEFF3',
    ShiftAccepted: '#73DDC0',
    ShiftAssigned: '#73DDC0',
    ShiftCancelled: '#DAE1E9',
    ShiftCompleted: '#707985',
    ShiftOpen: '#F5C9A0',
    ShiftPending: '#F5C9A0',
    ShiftRejected: '#45424E',
    ShiftRequested: '#F5C9A0',
    ShiftUnfulfilled: '#45424E',
    ShiftTimeOff: '#F7F9FC',
    ShiftOtherPosition: '#bfbfdc',
    ShiftUnfulfilledStroke: '#961E36',
    ShiftSwapped: '#3F6FA8',
    ShiftAbsent: '#FFCADA',
};
//# sourceMappingURL=BKJColors.js.map